export enum messagingPlatform {
  FacebookMessenger = 'FacebookMessenger',
  WhatsApp = 'WhatsApp',
}

export interface IMessagingPlatform {
  platformName: string;
  platformLink: string | null;
}

export class MessagingPlatformConfig {
  public static platformList: IMessagingPlatform[] = [
    {
      platformName: messagingPlatform.FacebookMessenger,
      platformLink: 'https://m.me/100194089069222',
    },
    {
      platformName: messagingPlatform.WhatsApp,
      platformLink: 'https://wa.me/+16506704531',
    },
  ];
}
